<template>
<div id="watermarkTransfer">
    <div class="check-item-positions">
        <div class="icon-util" style="float:left" :class="[delWatermark?'check-small':'nocheck-small-blue']" @click="delWatermark=!delWatermark"></div>
        <div class="check-item-position"><span>{{$t('language.emailTransfer.delWatermark')}}</span></div>
    </div>
</div>
</template>

<script>
import cloudSelect from "@/components/common/select/cloud_select";
export default {
    components: {
        "cloud-select": cloudSelect
    },
    data: function () {
        return {
            delWatermark: false,
        }
    },
    methods: {
        init() {
            this.delWatermark = false;
        },
    }

};
</script>

<style scoped>
#watermarkTransfer {
    display: flex;
    flex-direction: column;
}

.icon-util {
    margin-top: 2px;/*no*/
    cursor: pointer;
}

.check-item-positions {
    margin-bottom: 10px;/*no*/
}

.check-item-position {
    position: unset;
    float:left;
    line-height: 20px;/*no*/
    margin-left: 5px;/*no*/
    max-width: calc(100% - 20px);/*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_options/tab_email_watermark.vue